import React, { useEffect } from 'react';

/**
 * Notification System Component
 * Displays real-time notifications from WebSocket
 */
const NotificationSystem = ({ notifications, setNotifications }) => {
  // Auto-remove notifications after 5 seconds
  useEffect(() => {
    if (notifications.length > 0) {
      const timer = setTimeout(() => {
        setNotifications(prev => prev.slice(1));
      }, 5000);
      return () => clearTimeout(timer);
    }
  }, [notifications, setNotifications]);

  if (notifications.length === 0) return null;

  return (
    <div className="fixed top-4 right-4 z-[10000] space-y-2">
      {notifications.map(notification => (
        <div
          key={notification.id}
          className="bg-blue-600 text-white px-4 py-3 rounded-lg shadow-lg max-w-sm flex items-center justify-between"
        >
          <div className="flex items-center">
            <span className="mr-2">
              {notification.type === 'bus_approaching' ? '🚌' : '📢'}
            </span>
            <span className="text-sm">{notification.message}</span>
          </div>
          <button
            onClick={() => setNotifications(prev => prev.filter(n => n.id !== notification.id))}
            className="text-white hover:text-gray-200 ml-2"
          >
            ✕
          </button>
        </div>
      ))}
    </div>
  );
};

export default NotificationSystem;